/**
 * Catálogo de avatares. ARQUIVO GERADO — não edite à mão.
 *
 * Sai de `scripts/avatares.sh`, que lê `web/public/avatares/`.
 * Para acrescentar um avatar, coloque o arquivo lá e rode o script.
 * Ver docs/AVATARES.md.
 */

export const AVATARES = [
  '01-topete',
  '02-loira-ondulada',
  '03-jaqueta-mostarda',
  '04-listrado-lilas',
  '05-tulipas',
  '06-rosa-listrado',
  '07-oculos-redondos',
  '08-gargantilha',
  '09-gola-plissada',
  '10-lenco-azul',
  '11-rabo-de-cavalo',
  '12-gorro-amarelo',
  '13-topete-loiro',
  '14-bicolor',
  '15-rosa-colar',
  '16-fones-azuis',
  '17-bone-rosa',
  '18-jardineira',
  '19-cabelo-violeta',
  '20-cachos-brancos',
  '21-franja-roxa',
  '22-coque-branco',
  '23-brincos-azuis',
  '24-grisalho-roxo',
  '25-violeta-amarelo',
  '26-lenco-grisalho',
  '27-grisalho-lilas',
  '28-violeta-jardineira',
  '29-fones-brancos',
  '30-grisalho-rosa',
  '31-barba-branca',
  '32-jaqueta-amarela',
  '33-turbante-azul',
  '34-oculos-escuros',
  '35-longo-laranja',
  '36-chanel',
  '37-jaqueta-laranja',
  '38-brincos-verdes',
  '39-coque-marrom',
  '40-loiro-marinho',
  '41-lenco-amarelo',
  '42-listras-laranja',
  '43-loira-jardineira',
  '44-fones-lilas',
  '45-gola-branca',
  '46-ruiva',
  '47-cardiga-verde',
  '48-turbante-dourado',
] as const;

export type AvatarId = (typeof AVATARES)[number];
